import Form from "./ui/form.coffee";

const UI = {
  Form
};

export default UI;
